import { type AlertVariant } from "@patternfly/react-core";
import { createContext, ReactNode } from "react";

export type ToastVariant = Exclude<keyof typeof AlertVariant, "default">;
export type Toast = {
  variant?: ToastVariant;
  timeout?: boolean | number;
  dismissable?: boolean;
  content?: ReactNode;
};

export type ToastContextType = (alert: Toast) => void;
const noop = () => {
  // Do nothing
};

const ToastContext = createContext<ToastContextType>(noop);
export default ToastContext;
